import React, { useRef } from "react"

import { Form, Formik } from "formik"
import * as Yup from "yup"

import readFile from "src/readFile"

import { gql, useClient, useMutation } from "hooks/urql"

import {
  FileField,
  FormFailures,
  SubmitButton,
  TextAreaField,
  handleFailure,
} from "components/Forms/Formik/hookComponents"

export type SendMessageProps = {
  threadId: string
}

const ValidationSchema = Yup.object().shape({
  content: Yup.string().required("Message body required"),
})

const SendMessage: React.FC<SendMessageProps> = ({ threadId }) => {
  const client = useClient()
  const formState = { content: "", threadId }
  const fileField = useRef<any>()
  const [, runMutation]: any[] = useMutation(createMessageMutation, client)

  const handleSubmit = (values, actions) => {
    const params = { ...values }
    readFile(values.attachment)
      .then(fileResult => {
        params.attachment = fileResult
        runMutation(params)
          .then(result => {
            const { failures } = result.data.createMessage

            if (failures.length > 0) {
              handleFailure(actions, failures)
            } else {
              actions.resetForm()
              if (fileField.current) fileField.current.value = ""
              actions.setSubmitting(false)
            }
          })
          .catch(() => handleFailure(actions))
      })
      .catch(() => handleFailure(actions))
  }

  return (
    <div className="mb-10">
      <Formik
        initialValues={formState}
        onSubmit={handleSubmit}
        validationSchema={ValidationSchema}
      >
        <Form>
          <TextAreaField
            name="content"
            placeholder="Send a message"
            rows={2}
            autoFocus
          />
          <FileField name="attachment" label="Attach File" ref={fileField} />
          <FormFailures />
          <SubmitButton text="Send Message" className="btn solid small blue" />
        </Form>
      </Formik>
    </div>
  )
}

const createMessageMutation = gql`
  mutation CreateMessage(
    $threadId: ID!
    $content: String!
    $attachment: FileInputObject
  ) {
    createMessage(
      messageThreadId: $threadId
      content: $content
      attachment: $attachment
    ) {
      failures {
        message
      }
      messageThread {
        id
      }
    }
  }
`

export default SendMessage
